<pux-translate :text="hasNoSpalten ? hasNoSpaltenLabel : label"></pux-translate>